const state = {
  auctions: [],
  viewingAuctionModel: {},
  legacyAuctionRankInList: null,
  timerInterval: null,
  hasMorePages: true,
  auctionLanesRefreshing: true,
  selectedAuctionLane: null,
  selectedAuctionLaneSubFilter: {},
  syncAuctionsDataRequest: null,
  lastSyncAuctionsDataRequestTimestamp: new Date(),
  auctionIdsWaitingToSync: [],
  adHocSearchIsActive: false,
  savedSearchIsActive: false,
  auctionSubscriptions: {},
};

export default state;
